@if (state$ | async; as state) {
<button
  [class.-without-icon]="!state.hasIcon"
  [class.-without-label]="!state.hasTextContent || type === buttonType.Close"
  [class.-fixed]="fixed"
  [disabled]="disabled"
  class="a-button tw-w-full {{ buttonTypeClassesMap[type] }}"
  type="button"
>
  @if (type !== buttonType.Close) {
  <span
    class="tw-flex"
    [class.tw-p-3]="state.hasIcon && !state.hasTextContent"
    [class.tw-py-3]="state.hasIcon && state.hasTextContent"
    [class.tw-pl-3]="state.hasIcon && state.hasTextContent"
    [class.tw-pr-2]="state.hasIcon && state.hasTextContent"
  >
    <ng-content select="[button-icon]"></ng-content>
  </span>

  @if (state.hasTextContent) {
  <span class="a-button__label">
    <ng-content></ng-content>
  </span>
  } } @else {
  <bosch-ui-icon [name]="closeIcon" [isButtonIcon]="true"></bosch-ui-icon>
  }
</button>
}
